import Favicon from 'favico.js'
import {fromJS} from 'immutable'
import moment from 'moment'

import {
  PRESENCE,
  USER_MESSAGE_NOTIFICATIONS_ENDPOINT,
  VIEWPORT_TYPES
} from '../../config/constants'

import {
  SET_NEW_MESSAGE_NOTIFICATION,
  SET_NEW_SESSION_REQUEST_NOTIFICATION,
  SET_NEW_NOTIFICATION
} from '../action_types'

import DesktopNotificationsHandler from '../../lib/desktop_notifications_handler'

import firedux from '../firedux'
import {dispatch} from '../store'

import openConversation from '../setters/open_conversation'
import setLastOpenTimeForConversation from '../actions/set_last_open_time_for_conversation'

const openConversationFromNotification = (currentUserUid, message, viewportType) => {
  const {from, type, conversationId} = message
  if (!currentUserUid || !from || !conversationId) return

  openConversation(currentUserUid, from, conversationId, type, viewportType)
}

const setIsReceivedForNotification = (uid, notifId) => {
  const ENDPOINT = `${USER_MESSAGE_NOTIFICATIONS_ENDPOINT(uid)}/${notifId}/isReceived`

  firedux.ref.child(ENDPOINT).set(true)
}

let desktopNotificationsHandler = new DesktopNotificationsHandler() 

const updateLastOpenTimeForConversation = (conversationId) => {
  const now = moment().valueOf()
  // TODO: find better way to update/force input focus for conversations.
  // calling dispatch inside middleware is nasty.
  dispatch(setLastOpenTimeForConversation(conversationId, now))
}

const notifyDesktop = (notification, key, uid) => {
  if (notification.isReceived) return

  const desktopNotif = desktopNotificationsHandler.notify(notification)
  const {conversationId} = notification.payload

  desktopNotif.addEventListener('show', () => setIsReceivedForNotification(uid, key))

  if (conversationId) {
    desktopNotif.addEventListener(
      'click', updateLastOpenTimeForConversation.bind(null, conversationId)
    )
  }
}

let originalPageTitle
let pageTitleInterval
let unreadMessageCount = 0

let pageTitleNotificationsHandler =
  new Favicon({animation: 'slide', position: 'up'})

const notifyPageTitle = (notification, newCount = 0) => {
  if (!originalPageTitle) originalPageTitle = document.title

  let notifTitle = `${notification.title} -${notification.body}`
  unreadMessageCount += newCount
  pageTitleNotificationsHandler.badge(unreadMessageCount)

  if (pageTitleInterval) clearInterval(pageTitleInterval)

  let swapTitle = () => {
    if (document.hasFocus()) {
      clearInterval(pageTitleInterval)
      document.title = originalPageTitle
      pageTitleNotificationsHandler.reset()
      unreadMessageCount = 0

      return
    }

    document.title = notifTitle

    setTimeout(() => document.title = originalPageTitle, 600)
  }

  pageTitleInterval = setInterval(swapTitle, 1200)
  swapTitle()
}

const notifySessionRequest = (store, notificationPayload) => {
  const user = store.getState().getIn(['users', notificationPayload.from])

  let title = 'New Session Request'
  let body = 'You have a new immediate session request'
  let icon = null
  const tag = notificationPayload.tag

  if (user) {
    title = title + ' From ' + user.get('name')
    body = `${user.get('name')} requested a new immediate session...`
    icon = user.get('profileImage')
  }

  desktopNotificationsHandler.notify({title, body, tag, icon})
}

const handleNewMessageNotification = (uid, isActive, ignoredUsers, viewportType, action, next) => {
  const notification = action.notification
  const key = action.key

  if (!notification) return next(action)
  if (notification.isReceived) return next(action)

  if (ignoredUsers && ignoredUsers[notification.from]) {
    setIsReceivedForNotification(uid, key)
    return next(action)
  }

  if (viewportType === VIEWPORT_TYPES.DESKTOP) {
    openConversationFromNotification(uid, notification.payload, viewportType)
  }

  if (isActive) {
    desktopNotificationsHandler.markAllAsRead()
    setIsReceivedForNotification(uid, key)
    return next(action)
  }

  notifyDesktop(notification, key, uid)
  notifyPageTitle(notification, 1)

  return next(action)
}

export default store => next => action => {
  const currentUser = store.getState().get('currentUser', fromJS({})).toJS()
  const viewportType = store.getState().getIn(['viewport', 'type'])
  const {uid, presence, isActive, ignored: ignoredUsers} = currentUser

  if (!(uid)) return next(action)
  // TODO: test this if it is working.
  if (presence === PRESENCE.OFFLINE) return next(action)

  if (action.type === SET_NEW_MESSAGE_NOTIFICATION) {
    return handleNewMessageNotification(uid, isActive, ignoredUsers, viewportType, action, next)
  }
  else if (action.type === SET_NEW_SESSION_REQUEST_NOTIFICATION) {
    if (!isActive) {
      notifySessionRequest(store, action.notification)
      return next(action)
    }
  }
  else if (action.type === SET_NEW_NOTIFICATION) {
    if (!action.options) return next(action)
    if (isActive) return next(action)

    const {title, desktop} = action.options

    if (title) notifyPageTitle(action.notification, 1)
    if (desktop) {} // TODO: add notify desktop for this.
  }

  return next(action)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/middlewares/notifications.js
 **/